import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Designations = lazy(() => import('./Designations'))
const Roles = lazy(() => import('./Roles'))
const MembershipTypes = lazy(() => import('./MembershipTypes'))
const CommitteeTypes = lazy(() => import('./CommitteeTypes'))
const Users = lazy(() => import('./Users'))
const CommentCategories = lazy(() => import('./CommentCategories'))
const TechnicalExpertise = lazy(() => import('./TechnicalExpertise'))
const DocumentTypes = lazy(() => import('./DocumentTypes'))
const NationalPositionDocuments = lazy(() => import('./NationalPositionDocuments'))
const NationalPositionDocumentView = lazy(() => import('./NationalPositionDocumentView'))

const dataSetupsRoutes = [
    {
        path: '/setup/designations',
        component: Designations,
        auth: authRoleAccess.designations_setup,
    },
    {
        path: '/setup/roles',
        component: Roles,
        auth: authRoleAccess.roles_setup,
    },
    {
        path: '/setup/membership-types',
        component: MembershipTypes,
        auth: authRoleAccess.membership_types_setup,
    },
    {
        path: '/setup/committee-types',
        component: CommitteeTypes,
        auth: authRoleAccess.committee_types_setup,
    },
    {
        path: '/setup/users',
        component: Users,
        auth: authRoleAccess.users_setup,
    },
    {
        path: '/setup/comment-categories',
        component: CommentCategories,
        auth: authRoleAccess.comment_categories_setup,
    },
    {
        path: '/setup/technical-expertise',
        component: TechnicalExpertise,
        auth: authRoleAccess.technical_expertise_setup,
    },
    {
        path: '/setup/document-types',
        component: DocumentTypes,
        auth: authRoleAccess.document_types_setup,
    },
    {
        path: '/setup/national-position-documents',
        component: NationalPositionDocuments,
        auth: authRoleAccess.national_position_documents_setup,
    },
    {
        path: '/setup/national-position-documents/:id',
        component: NationalPositionDocumentView,
        auth: authRoleAccess.national_position_documents_setup,
    },
]

export default dataSetupsRoutes